module.exports = __webpack_public_path__ + "img/20200501_160737.5767d755.jpg";